// Utilities
import { defineStore } from 'pinia';

interface AppState {
  pageTitle: string;
  gamenMode: string;
  showHomeBtn: boolean;
  errflg: boolean;
  finishFlg: boolean;
  closeFlg: boolean;
  init: boolean;
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    pageTitle: 'Login Page',
    gamenMode: '',
    showHomeBtn: true,
    errflg: false,
    finishFlg: false,
    closeFlg: true,
    init: false,
  }),
  actions: {
    setPageTitle(title: string) {
      this.pageTitle = title;
    },
    setGamenMode(mode: string) {
      this.gamenMode = mode;
    },

    setShowHomeBtn(show: boolean) {
      this.showHomeBtn = show;
    },

    setErrFlg(flag: boolean) {
      this.errflg = flag;
    },

    setFinishFlg(flag: boolean) {
      this.finishFlg = flag;
    },

    setCloseFlg(flag: boolean) {
      this.closeFlg = flag;
    },
    setInit(flag: boolean) {
      this.init = flag;
    },
  },
});
